import { render, staticRenderFns } from "./BuildRowsList.vue?vue&type=template&id=26a25808&scoped=true&"
import script from "./BuildRowsList.vue?vue&type=script&lang=js&"
export * from "./BuildRowsList.vue?vue&type=script&lang=js&"
import style0 from "./BuildRowsList.vue?vue&type=style&index=0&id=26a25808&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a25808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VContainer,VDataTable,VRow,VTooltip})
